import { Component, ViewEncapsulation, OnInit, TemplateRef, ViewChild, OnDestroy, Injector, signal, computed, effect } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
//import { SecretService } from "./services/secret.service";
//import { AdalService } from "ng2-adal/dist/services/adal.service";
import { FlowManagementService } from './services/flow-management.service';
import { Flow } from './obj/Flow';
import { Router, NavigationExtras, NavigationEnd, ActivationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { Settings } from './flows/settings';
import { DialogService, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { ChangelogComponent } from './changelog/changelog.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { SubscriptionPaymentComponent } from './subscription-payment/subscription-payment.component';
import { PaymentService, LAST_SUB } from './services/payment.service';
import { NotificationService, NotificationRef } from '@progress/kendo-angular-notification';
import { FlowEventService } from './services/flow-event.service';
import { BehaviorSubject, Subject, Subscription, combineLatest, interval, of } from 'rxjs';
import { MsalBroadcastService, MsalCustomNavigationClient } from '@azure/msal-angular';
//import { AnalyticsService } from './services/analytics.service';
import { MsalHelperService, ReauthPrompt } from './services/msal-helper.service';
//import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ApplicationInsightsService } from './services/application-insights.service';
import { /* Angulartics2Mixpanel, */ Angulartics2GoogleTagManager } from 'angulartics2'
import { SwUpdate } from '@angular/service-worker';
import { HttpCancelService } from './services/http-cancel.service';
import { AccountInfo, InteractionStatus } from '@azure/msal-browser';
import { filter, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { ENV_SCAN_STALE_MS, formatAge, formatAgeAgo } from './services/env-scan.util';
import { Location } from '@angular/common';
import { StorageRouterService } from './services/storage-router.service';
import { StorageWorkerClientService } from './services/storage-worker-client.service';
import { IconSettingsService, IconSettings } from "@progress/kendo-angular-icons";
import { ServicesComponent } from './offerings/services.component';
import { McpAnnounceComponent } from './mcp/mcp-announce.component';
import { WebinarPromoComponent, WEBINAR_SEEN_KEY, WEBINAR_SLUG, isWebinarActive } from './mcp/webinar-promo.component';
import { WhatsNewComponent } from './whats-new/whats-new.component';
import { FluentUIService } from './services/fluent-ui.service';
// html2canvas-pro loaded dynamically inside captureFeedbackScreenshot() — supports modern CSS color() functions
// import 'autotrack/lib/plugins/event-tracker';
// import 'autotrack/lib/plugins/outbound-link-tracker';
// import 'autotrack/lib/plugins/url-change-tracker';
//import 'autotrack';
//import 'autotrack/autotrack.js';

//var ga = window['ga'];

//ga('create', 'UA-123261050-1', 'auto');

// Only require the plugins you've imported above.
// ga('require', 'eventTracker');
// ga('require', 'outboundLinkTracker');
// ga('require', 'urlChangeTracker');
//ga('send', 'pageview');

//appInsights.trackPageView();
const REFRESH_T = 60 * 60 * 1000;  // 1hr - refresh shouldn't need to be called that frequently now with MSAL able to refetch on demand
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [
        // '../../node_modules/@progress/kendo-theme-material/dist/all.css',
        './app.component.scss'
    ],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    @ViewChild('templateNotification', { read: TemplateRef, static: true }) public notificationTemplate: TemplateRef<any>;
    environmentMenuOpen = false;
    userMenuOpen = false;
    refreshProgressOpen = false;
    // True when the active route should render with the simple shell layout
    // (natural document scroll). False = app-interior layout with a fixed-
    // height shell where children own scroll (e.g. Kendo grids on /flows).
    shellPage = false;

    dropdownPositionsLeft: ConnectedPosition[] = [
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    ];
    dropdownPositionsRight: ConnectedPosition[] = [
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    ];

    title = 'Kunai App';
    subTitle = '(A Flow Tool)';
    appVersion = environment.VERSION;
    user: AccountInfo;
    environments: any;
    environment: string;
    menu: any[] = [
        {
            text: 'Get Started / Sign in',
            // nav_icon: 'user',
            ms_icon: 'IDBadge',
            disabled: false,
            items: [
            ]
        },
        {
            text: 'Environment',
            items: [
//              { text:'Refresh', nav_icon: 'refresh'}
            ],
            disabled: true,
            hidden: true,
            ms_icon: 'MapLayers'
            // nav_icon: 'aggregate-fields',
        }
    ];

    nav: any[] = [
        {
            text: `FlowStudio v${environment.VERSION}`,
            internal: 'Product'
            //url: 'http://johnliu.net/flow-studio/',
            //target: '_blank',
            //nav_icon: 'info'
        },
        // {
        //     text: 'Flows',
        //     url: '/flows',
        //     nav_icon: 'track-changes-accept',
        //     disabled: true,
        // },
        // {
        //     text: 'Admin',
        //     url: '/admin',
        //     nav_icon: 'track-changes-accept-all',
        //     disabled: true,
        // },
        // {
        //     text: 'Approvals',
        //     url: '/approvals',
        //     nav_icon: 'checkbox-checked',
        //     disabled: true,
        // },
        // {
        //     text: 'Connections',
        //     url: '/connections',
        //     nav_icon: 'file-ascx',
        //     disabled: true,
        // },
        // {
        //     text: 'Runs',
        //     icon: 'form-element',
        //     disabled: true,
        // },
        {
            internal: 'Subscription',
            text: `Buy`,
            disabled: true,
            hidden: true
            //     text: `Subscription`
        },
        {
            text: 'Feedback',
            internal: 'Feedback',
            // nav_icon: 'comment',
            hidden: true
        },
        /*
        {
            internal: 'Stream',
            text: `Live Stream`,
            disabled: true,
            hidden: true
        }
        */
        {
            text: 'FAQ',
            internal: 'Learn',
            url: 'https://learn.flowstudio.app/faq',
            target: 'learn',
            hidden: false
        },
        {
            text: 'Services',
            internal: 'Services',
            hidden: false
        },
        {
            text: 'MCP',
            internal: 'MCP',
            hidden: true,
            cssClass: ''
        },
        // {
        //     text: 'Update',
        //     internal: 'Update',
        //     target: 'learn',
        //     hidden: true
        // }
    ];

    selectedFlow: Flow;
    error: any = null;
    notification: NotificationRef = null;
    public isIframe: boolean;
    public isFeedbackDialogOpen = false;
    /** Guards the once-per-session auto-show attempt for the webinar promo. */
    private webinarAutoShowChecked = false;
    //private subscriptions: Subscription[] = [];
    private _destroying$ = new Subject<void>();
    private subscription = new Subscription();
    loggedIn: boolean;

    hasUpdate$ = new BehaviorSubject(null);
    reauthPrompt$: BehaviorSubject<ReauthPrompt | null>;
    reauthPromptModal$: BehaviorSubject<ReauthPrompt | null>;

    /** Header scan state — true while a scan is running, false otherwise. Driven by the orchestrator. */
    scanLoading$ = this.flowEventService.scanLoading$;
    scanProgress$ = this.flowEventService.scanProgress$;

    /**
     * Active scan source for the current page. Drives which environments-table
     * timestamp the header reload-button reads. Updated from router events so
     * navigating /flows ↔ /admin ↔ /connections re-points the freshness clock.
     */
    private currentScanSource$ = new BehaviorSubject<'flows' | 'flowsAdmin' | 'connections'>('flows');

    /**
     * Header age label for the current env — emits formatted strings like
     * "Refreshed 1h 33m ago" or `null` when no env has been scanned yet.
     * Re-emits on env change, on scan-loading transitions (so the label updates
     * after a scan completes), on route change, and on a 60 s tick (for live aging).
     *
     * Source mapping:
     *   /admin               → flowsAdminScannedAt
     *   /connections (any)   → MIN(connectionsScannedAt, connectionsAdminScannedAt)
     *                          — older of the two so "stale" reflects either scope
     *   everything else      → scanCompletedAt (user-scope flows)
     */
    scanAge$ = combineLatest([
        this.flowManagementService.currentEnvironment$,
        this.flowEventService.scanLoading$,
        this.currentScanSource$,
        interval(60_000).pipe(startWith(0)),
    ]).pipe(
        switchMap(async ([envName, , source]) => {
            if (!envName) return null;
            const stored = await this.storageRouterService.getEnvironment(envName).catch(() => null);
            if (!stored) return null;

            let scannedAt: number | null = null;
            if (source === 'flowsAdmin') {
                scannedAt = stored.flowsAdminScannedAt;
            } else if (source === 'connections') {
                const u = stored.connectionsScannedAt;
                const a = stored.connectionsAdminScannedAt;
                if (u != null && a != null) {
                    scannedAt = Math.min(u, a);
                } else {
                    scannedAt = u ?? a;
                }
            } else {
                scannedAt = stored.scanCompletedAt;
            }

            if (!scannedAt) return null;
            const elapsed = Date.now() - scannedAt;
            return {
                age: formatAge(elapsed),
                /** Reads correctly for sub-minute ages too ("just now" — no trailing " ago"). */
                label: formatAgeAgo(elapsed),
                stale: elapsed > ENV_SCAN_STALE_MS,
            };
        }),
    );

    membershipStatus = '';
    private paymentService: PaymentService | null = null;
    private locationSig = signal(window.location.host.toLowerCase());
    private reauthRefreshTick = signal(0);
    isApp = computed(() => !environment.web && (this.locationSig().startsWith('localhost:') || ['dev.flowstudio.app', 'prod.flowstudio.app'].includes(this.locationSig())));

    verifyUser() {

        this.user = this.msalHelperService.getUser();
        if (this.user) {
            this.loggedIn = true;
            this.appInsights.setUserId(this.user.username);
        }
        else {
            this.loggedIn = false;
            this.appInsights.clearUserId();
            return;
        }

        //this.user = user;
        this.menu[0].text = `${this.user.name}`;

        this.paymentService?.membership$.subscribe((membership) => {

            this.membershipStatus = membership.status;
            const product = `FlowStudio`;
            if (membership.status == 'Active') {
                // this.nav[navSubscriptionIndex].text = 'Subscription';
                this.nav[0].text = `${product} v${environment.VERSION}`;
                this.nav[1].text = `Subscriber`;
            }
            else if (membership.status == 'Enterprise') {
                this.nav[0].text = `${product} v${environment.VERSION}`;
                this.nav[1].text = `Enterprise`;
            }
            else if (membership.status == '') {
                // this.nav[navSubscriptionIndex].text = 'Buy';
                this.nav[0].text = `${product} v${environment.VERSION}`;
            }
            else {
                // this.nav[navSubscriptionIndex].text = 'Buy';
                this.nav[0].text = `${product} v${environment.VERSION} (${membership.status})`;
            }
        });
        this.paymentService?.verify();

        this.flowManagementService.serviceStatus$.next(`User ${this.user.name} logged in...`);
        this.flowManagementService.log().then((result) => {
            //debugger;
            var r = result;
        });

    }

    ngOnInit(): void {

        // var requestInfo = this.secretService.handleWindowCallback();

        // if (requestInfo) {
        //     debugger;
        // }
        // if (requestInfo && requestInfo.parameters && requestInfo.parameters.access_token) {

        //     this.storageRouterService.getSetting(Settings.SETTING_SERVER).then(useServer=>{
        //         if (useServer.value !== false) {
        //             this.flowManagementService.server(requestInfo);
        //         }
        //     });
        // }
        this.isIframe = window !== window.parent && !window.opener;

        if (this.isIframe) {
            return;
        }

        // Best-effort one-shot wipe of legacy Dexie IndexedDB databases. The
        // app switched to OPFS/SQLite for persistence; old `fs-dx-*` databases
        // serve no purpose and only consume the browser's storage quota.
        this.storageRouterService.purgeLegacyDexieDatabases();

        // pwa update check — keep no user on a stale build:
        //   1. versionUpdates auto-activates as soon as a new version is READY
        //   2. unrecoverable state (corrupt SW) → unregister + hard reload
        //   3. checkForUpdate fires every 30s, plus on tab visibility/focus to
        //      catch users who left the tab open in the background where the
        //      30s timer gets throttled.
        this.subscription.add(
            this.swUpdate.versionUpdates.subscribe( (updateEvent)=>{
                if (updateEvent.type === "VERSION_DETECTED") {
                    this.hasUpdate$.next(updateEvent.version.appData);
                }

                if (updateEvent.type === "VERSION_READY") {
                    this.hasUpdate$.next(updateEvent.latestVersion.appData);
                    this.activateUpdate();
                }
            })
        );

        if (this.swUpdate.isEnabled) {
            // Recover from broken/desynced service workers — force-unregister and reload
            // so the user lands on a known-good version instead of a half-cached one.
            this.subscription.add(
                this.swUpdate.unrecoverable.subscribe(({ reason }) => {
                    console.warn('[swUpdate] unrecoverable:', reason);
                    if (navigator.serviceWorker?.getRegistrations) {
                        navigator.serviceWorker.getRegistrations()
                            .then((regs) => Promise.all(regs.map((r) => r.unregister())))
                            .finally(() => document.location.reload());
                    } else {
                        document.location.reload();
                    }
                })
            );

            // Periodic check every 30s.
            this.subscription.add(
                interval(30000)
                    .pipe(takeUntil(this._destroying$))
                    .subscribe(() => {
                        this.swUpdate.checkForUpdate().catch(err => {
                            console.log('Update check failed:', err);
                        });
                    })
            );

            // Catch users coming back to a backgrounded tab where the timer was throttled.
            const onVisibility = () => {
                if (document.visibilityState === 'visible' && this.swUpdate.isEnabled) {
                    this.swUpdate.checkForUpdate().catch(err => {
                        console.log('Update check on visibilitychange failed:', err);
                    });
                }
            };
            document.addEventListener('visibilitychange', onVisibility);
            this._destroying$.subscribe(() => document.removeEventListener('visibilitychange', onVisibility));
        }

        this.verifyUser();
        this.maybeAutoShowWebinar();
        this.subscription.add(
            this.msalHelperService.user$.subscribe((user)=>{
                if (this.user == null && user != null) {
                    this.user = user;
                    this.loggedIn = true;
                    this.menu[0].text = user.username || user.name || 'Account';
                    this.refreshEnvironments();
                    this.checkBuyIntent();
                    this.maybeAutoShowWebinar();
                    return;
                }
                else {
                    this.user = user;
                    this.loggedIn = (user !== null);
                    if (user) {
                        this.menu[0].text = user.username || user.name || 'Account';
                    }
                }
            })
        );

        this.subscription.add(
            this.broadcastService.inProgress$
                .pipe(
                    filter((status:InteractionStatus)=> status === InteractionStatus.None),
                    takeUntil(this._destroying$)
                )
                .subscribe((e)=>{
                    console.log("login success ");
                    // console.log(e);
                    //this.loggedIn = true;
        
                    //this.verifyUser();    
                })
        );

        this.subscription.add(
            this.msalHelperService.reauthCompleted$
                .pipe(filter((tick) => tick > 0))
                .subscribe(() => {
                    this.reauthRefreshTick.update((tick) => tick + 1);
                })
        );

        this.subscription.add(
            this.flowManagementService.serviceStatus$
                .pipe(takeUntil(this._destroying$))
                .subscribe((status) => {
                    const label = `${status || ''}`.trim();
                    if (!label) {
                        this.flowEventService.clearProgress('service-status');
                        return;
                    }
                    this.flowEventService.reportProgress({
                        id: 'service-status',
                        group: 'status',
                        label,
                        status: this.flowEventService.scanLoading$.value ? 'running' : 'done'
                    });
                })
        );

        this.subscription.add(
            this.flowEventService.scanLoading$
                .pipe(takeUntil(this._destroying$))
                .subscribe((loading) => {
                    if (!loading) {
                        this.flowEventService.completeRunningProgress();
                    }
                })
        );

        this.subscription.add(
            this.storageWorkerClient.scanProgress$
                .pipe(takeUntil(this._destroying$))
                .subscribe((progress) => {
                    if (!progress?.scanId) {
                        return;
                    }
                    this.flowEventService.reportProgress({
                        id: `worker-${progress.scanId}`,
                        group: 'worker',
                        label: progress.statusText || this.formatScanPhase(progress.phase),
                        status: progress.phase === 'completed'
                            ? 'done'
                            : progress.phase === 'cancelled'
                                ? 'cancelled'
                                : progress.phase === 'failed'
                                    ? 'failed'
                                    : 'running',
                        completed: progress.completed,
                        total: progress.total
                    });
                })
        );

        // this.subscriptions.push(this.broadcastService.subscribe("msal:loginSuccess", (payload) => {
        //     console.log("login success ");
        //     this.loggedIn = true;

        //     this.verifyUser();
        // }));
        this.subscription.add(
            this.router.events.subscribe(event => {
                if (event instanceof ActivationEnd) {
                    this.httpCancelService.cancelPendingRequests();
                }
                if (event instanceof NavigationEnd) {
                    this.shellPage = this.isShellPage(event.urlAfterRedirects);
                    this.persistLastRoute(event.urlAfterRedirects);

                    // Re-point the header reload-age clock at the column for
                    // whichever page we're on. /admin and /connections each have
                    // their own freshness; everything else maps to user-scope flows.
                    const url = event.urlAfterRedirects || '';
                    if (url.startsWith('/admin')) {
                        this.currentScanSource$.next('flowsAdmin');
                    } else if (url.startsWith('/connections')) {
                        this.currentScanSource$.next('connections');
                    } else {
                        this.currentScanSource$.next('flows');
                    }

                    const mcpItem = this.nav.find(i => i.internal === 'MCP');
                    if (mcpItem) {
                        mcpItem.hidden = event.urlAfterRedirects === '/';
                        mcpItem.cssClass = mcpItem.hidden ? '' : 'mcp-menu-item';
                    }

                    if (event.urlAfterRedirects == '/') {
                        return;
                    }
                    if (this.loggedIn) {
                        this.refreshEnvironments();
                    }
                }
            })
        );

        this.location.onUrlChange((url)=>{
            this.httpCancelService.cancelPendingRequests();
        });

        //this.adalService.handleWindowCallback();
        if (!this.loggedIn) {
            //this.logIn();

            if (window.self == window.top || !(window.frameElement && (window.frameElement.id.startsWith("adal")||window.frameElement.id.startsWith("msal")) )) {
                if (window.localStorage.getItem('msal.client.info') && !!this.flowManagementService.currentEnvironment) {
                    //this.login();
                }
            }
            return;
        }

        // menu
        this.subscription.add(
            this.flowEventService.showSubscription$.subscribe(() => {
                this.showSubscription();
            })
        );
        this.subscription.add(
            this.flowEventService.showFeedback$.subscribe(() => {
                this.showFeedback(null);
            })
        );
    }

    activateUpdate() {
        // pwa automatically reload latest version
        this.swUpdate.activateUpdate().then( ()=> {
            document.location.reload();
        });
    }


    timeout_id = null;

    private refreshEnvironments() {

        //debugger
        if (this.user === null) {
            return;
        }

        this.menu[1].disabled = false;
        this.menu[1].hidden = false;
        this.menu[0].items = [
            {
                text: `${this.user.username}`,
                //icon: 'user',
                ms_icon: 'IDBadge',
                //disabled: true
            },
            {
                text: "Sign out",
                //icon: 'logout',
                ms_icon: 'SignOut',
                disabled: false,
            }
        ];
        if (this.menu.length == 2) {
            this.menu.push({
                text: '',
                ms_icon: 'Refresh',
            });
        }

        // nav
        // this.nav = [
        //     {
        //         text: `FlowStudio v${environment.VERSION}`,
        //         //url: 'http://johnliu.net/flow-studio/',
        //         //target: '_blank',
        //         //nav_icon: 'info'
        //     },
        //     {
        //         text: `Trial`
        //         //     text: `Subscription`
        //     },
        //     {
        //         text: 'Feedback',
        //         nav_icon: 'comment'
        //     }
        // ];
        // navSubscriptionIndex = 1;
        // this.router.events.subscribe(e=>{
        //     if (e as NavigationEnd) {
        //         if (this.isNewUI) {
        //             this.nav = [
        //                 {
        //                     text: `FlowStudio v${environment.VERSION}`,
        //                     //url: 'http://johnliu.net/flow-studio/',
        //                     //target: '_blank',
        //                     //nav_icon: 'info'
        //                 },
        //                 {
        //                     text: `Trial`
        //                     //     text: `Subscription`
        //                 },
        //                 {
        //                     text: 'Feedback',
        //                     nav_icon: 'comment'
        //                 }
        //             ];
        //             navSubscriptionIndex = 1;
        //         }
        //     }
        // })
        var navSubscriptionIndex = 1;
        this.nav.forEach((nav) => {
            nav.disabled = false;
            nav.hidden = false;
        });

        //var pUser = this.authService.getUser();
        var pEnvironments = this.flowManagementService.getEnvironments().toPromise();
        // var pSettings = this.storageRouterService.getSetting(Settings.SETTING_ENVIRONMENT);
        // var pLastVersion = this.storageRouterService.getSetting(Settings.SETTING_LASTVERSION);
        // var pLastSub = this.storageRouterService.getSetting(Settings.SETTING_LASTSUB);
        //var pSets = this.storageRouterService.getSettings();
        const keys = [Settings.SETTING_ENVIRONMENT, Settings.SETTING_LASTVERSION, Settings.SETTING_LASTSUB];
        const pSets = this.storageRouterService.getConfigs(keys);

        // pUser.then((user) => {
        // });
        pEnvironments.then(() => {

            //var t = 5 * 60 * 1000;  // 5min
            //this.refreshEnv();
            // this.flowManagementService.server(this.membershipStatus == "Active");
            // setTimeout(this.refreshEnv, REFRESH_T);
        });
        Promise.all([pEnvironments, /*pSettings, pLastVersion, pLastSub,*/ pSets]).then(([rEnvs, /*settings, version, sub,*/ sets]) => {

            const [settings, version, sub] = sets;
            // var settings = sets[Settings.SETTING_ENVIRONMENT];
            // var version = sets[Settings.SETTING_LASTVERSION];
            // var sub = sets[Settings.SETTING_LASTSUB];
            if (!rEnvs) {
                // skip
                return;
            }

            // Cache each discovered environment's identity in OPFS so the header
            // can render before any scan runs. Bulk write to avoid parallel-persist
            // races on the OPFS file. Does NOT touch scanCompletedAt.
            const rawEnvs: any[] = Array.isArray(rEnvs.value) ? rEnvs.value : [];
            this.storageRouterService.putEnvironments(rawEnvs).catch((err) => {
                console.warn('[AppComponent] putEnvironments failed', err);
            });

            var envs = rEnvs.value.map((item) => {
                return {
                    'text': item.properties.displayName,
                    'environment': item.name,
                    'isDefault': item.properties.isDefault
                };
            }).sort((a, b) => a.text.localeCompare(b.text));

            //debugger;
            if (envs.length > 1) {
                this.menu[1].items = [/*{ text:'Refresh', nav_icon: 'refresh'}, */ ...envs];

                this.appInsights.trackEvent('env', { 'envs': envs.length });
            }

            var env = null;
            if (settings && settings.value) {
                env = envs.filter(e => e.environment == settings.value);
            }
            else {
                env = envs.filter(e => e.isDefault);
            }

            if (env && env.length) {
                this.selectEnvironment(env[0].environment, env[0].text);
            }
            else {
                this.selectEnvironment(envs[0].environment, envs[0].text);
            }

            if (sub && sub.value != LAST_SUB) {
                //this.showSubscription();
            }

        });
    }

    /*
    refreshEnv() {
      if (this.flowManagementService.currentEnvironment) {
        this.flowManagementService.getEnvironment(this.flowManagementService.currentEnvironment).toPromise().then(
          () => {
              if (this.notification) {
                  this.notification.hide();
              }
              this.error = null;
          },
          (reason) => {
              this.error = reason;
              if (this.notification) {
                  this.notification.hide();
              }
              this.notification = this.notificationService.show({
                  content: this.notificationTemplate,
                  //animation: { type: 'fade', duration: 300 },
                  type: { style: 'warning', icon: true },
                  closable: true,
                  position: { horizontal: 'center', vertical: 'top' }
              });
              // if (this.nav.length == 3) {
              //     this.nav.push({
              //         text: 'Disconnected',
              //         icon: 'refresh'
              //     })
              // }
          }
        );
      }
      // this.flowManagementService.server(this.membershipStatus == "Active");
      if (this.timeout_id) {
          clearTimeout(this.timeout_id);
      }
      this.timeout_id = setTimeout(this.refreshEnv, REFRESH_T);
    };
    */

    ngOnDestroy() {

        this._destroying$.next(null);
        this._destroying$.complete();

        this.subscription.unsubscribe();

        // this.broadcastService.getMSALSubject().next(1);

        // if (this.subscriptions) {

        //     this.subscriptions.forEach(s=>s.unsubscribe());

        // }
    }

    constructor(
        //private adalService: AdalService,
        //private secretService: SecretService,
        private flowManagementService: FlowManagementService,
        private storageRouterService: StorageRouterService,
        private dialogService: DialogService,
        private router: Router,
        private notificationService: NotificationService,
        private flowEventService: FlowEventService,
        private broadcastService: MsalBroadcastService,
        // private msalService: MsalService,
        private msalHelperService: MsalHelperService,
        //private analytics: AnalyticsService,
        private appInsights: ApplicationInsightsService,
        //public angulartics2mixpanel: Angulartics2Mixpanel,
        public angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        private swUpdate: SwUpdate,
        private httpCancelService: HttpCancelService,
        private location: Location,
        public iconService: IconSettingsService,
        private fluentUIService: FluentUIService,
        private storageWorkerClient: StorageWorkerClientService,
        private injector: Injector
    ) {
        //this.adalService.init(this.secretService.adalConfig);
        // this.refresh.bind(this);
        // this.refreshEnv.bind(this);
        this.reauthPrompt$ = this.msalHelperService.reauthPrompt$;
        this.reauthPromptModal$ = this.msalHelperService.reauthPromptModal$;
        this.paymentService = this.injector.get(PaymentService, null);

        effect(() => {
            if (this.reauthRefreshTick() <= 0) {
                return;
            }

            this.refreshEnvironments();
        });
        
        //angulartics2mixpanel.startTracking();
        angulartics2GoogleTagManager.startTracking();
        
        iconService.notify({ type: "font" });

    }

    async getLastRoute() {
        const setting = await this.storageRouterService.getConfig(Settings.SETTING_LASTROUTE);
        const route = setting?.value || "/flows";
        return this.isPersistableLastRoute(route) ? route : "/flows";
    }

    private persistLastRoute(url: string): void {
        if (!this.isPersistableLastRoute(url)) {
            return;
        }

        this.storageRouterService.putConfig(
            Settings.SETTING_LASTROUTE,
            {
                key: Settings.SETTING_LASTROUTE,
                value: url
            }
        ).catch(() => {
            // Dexie may be unavailable briefly during auth transitions.
        });

        // Keep a lightweight fallback so redirect callback can always restore location.
        try {
            window.sessionStorage.setItem('flowstudio.lastRoute', url);
            window.localStorage.setItem('flowstudio.lastRoute', url);
        } catch {
            // ignore quota/privacy mode errors
        }
    }

    private isPersistableLastRoute(url: string): boolean {
        return !!url
            && url !== '/'
            && !url.startsWith('/token')
            && !url.startsWith('/login')
            && !url.startsWith('/debug')
            && !url.startsWith('/settings');
    }

    // Pages that should use natural document scroll (`.app-shell--scroll`)
    // instead of the fixed-height app shell. Use for content-heavy pages that
    // don't manage their own scroll container — debug tools, marketing/about,
    // settings forms. App-interior pages with grids (/flows, /admin) leave
    // this off so the grid owns the scroll.
    private isShellPage(url: string): boolean {
        if (!url) return false;
        if (url === '/') return true;
        // /settings was previously here (natural document scroll), but the page
        // sits inside the app shell with the sidebar, and document-level scroll
        // pushes the sidebar's "Settings" link off-screen. Switch to app-interior
        // layout — the page owns its own scroll via .settings-page overflow-y.
        return url.startsWith('/debug')
            || url.startsWith('/welcome');
    }

    selectEnvironment(environment: string, text: string): void {
        this.environment = environment;
        this.menu[1].text = text;
        //localStorage.setItem("env", this.environment);
        //this.router.navigate(['/flows', { environment: this.environment }]);

        this.flowManagementService.currentEnvironment = environment;
        this.appInsights.trackEvent('env', { 'select': environment })

        // if (window.self != window.top && window.frameElement && window.frameElement.id.startsWith("adal")) {
        //     this.getLastRoute().then(route => {
        //         //if (window.top.location.pathname != route) {
        //         window.top.location.href = route;
        //         //}
        //     });
        //     // inside adalFrame?
        //     //this.storageRouterService.updateSettings({'_id': Settings.SETTING_ENVIRONMENT, value: environment});
        //     //this.router.navigate(['/flows']);
        // }
    }

    /** Header "Refreshed X ago" button click — fire a forced re-scan of the current env. */
    public onScanRefreshClick(): void {
        this.flowEventService.manualRefresh$.emit();
    }

    /** Header "Cancel" button click — abort in-flight scan. */
    public onScanCancelClick(): void {
        this.flowEventService.cancelScan$.emit();
    }

    public onScanPrimaryClick(isLoading: boolean): void {
        if (isLoading) {
            this.onScanCancelClick();
            return;
        }
        this.onScanRefreshClick();
    }

    private formatScanPhase(phase: string): string {
        switch (phase) {
            case 'listing':
                return 'Fetching flows';
            case 'details':
                return 'Fetching flow details';
            case 'owners':
                return 'Fetching owners';
            case 'runs':
                return 'Fetching runs';
            case 'persisting':
                return 'Saving cache';
            case 'completed':
                return 'Completed';
            case 'cancelled':
                return 'Cancelled';
            case 'failed':
                return 'Failed';
            default:
                return 'Working';
        }
    }

    public refresh(force = false) {
        if (force) {
            this.flowManagementService.currentEnvironment = this.environment;
        }
        //this.refreshEnv();
        //window.location.href = '/'
        // this.getLastRoute().then(route => {
        //     this.router.navigate([route]);
        // });
    }

    login() {

        //this.analytics.send("app", "login")
        this.appInsights.trackEvent("app");
        this.flowManagementService.serviceStatus$.next("Logging in...");
        //this.authService.loginPopup( /*['user_impersonation', 'api://78c5bd67-31ba-4061-a311-13f2212530d3/user_impersonation']*/ /*["user.read", "api://a88bb933-319c-41b5-9f04-eff36d985612/access_as_user"]*/ );

        this.msalHelperService.login();
    }

    logout() {
        this.msalHelperService.logout();
    }

    public onSelect({ item }): void {
        if (item.text == 'Sign in' || item.text == 'Get Started / Sign in' ) {
            this.login();
            return;
        }
        if (item.text == 'Sign out') {
            window.localStorage.removeItem('adal.idtoken')
            this.logout();
            return;
        }
        if (item.nav_icon == 'refresh') {
            //this.router.navigate(['/flows', { environment: this.environment }]);
            this.refresh(true);
            return;
        }
        if (item.environment) {
            this.storageRouterService.putConfig(
                Settings.SETTING_ENVIRONMENT,
                {
                    key: Settings.SETTING_ENVIRONMENT,
                    value: item.environment
                }
            )
            // this.storageRouterService.updateSettings({
            //     _id: Settings.SETTING_ENVIRONMENT,
            //     value: item.environment
            // });
            this.selectEnvironment(item.environment, item.text);
            return;
        }
        if (item.internal == "Product" /*|| item.text.startsWith('FlowStudio') || item.text.startsWith('PowerStudio')*/ ) {
            this.showChangeLog(item);
            return;
        }
        if (item.internal == "Feedback" /*|| item.text == 'Feedback'*/) {
            this.showFeedback(item);
            return;
        }
        if (item.internal == "Subscription" /*|| item.text == 'Trial' || item.text == 'Buy' || item.text == 'Subscription' || item.text == 'Subscriber'  || item.text == 'Enterprise' */) {
            this.showSubscription();
            return;
        }
        if (item.internal == "Services") {
            this.showServices();
            return;
        }
        if (item.internal == "MCP") {
            this.showMcp();
            return;
        }
    }

    public showChangeLog(item) {
        const dialogRef = this.dialogService.open({
            title: `Change Log ${environment.VERSION}`,
            content: ChangelogComponent,
            //height: 800,
            height: 600,
            minWidth: 600,

            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });

        dialogRef.result.toPromise().then((result: DialogCloseResult) => {
            // return this.storageRouterService.updateSettings({ _id: Settings.SETTING_LASTVERSION, value: environment.VERSION });
            return this.storageRouterService.putConfig(
                Settings.SETTING_LASTVERSION,
                {
                    key: Settings.SETTING_LASTVERSION,
                    value: environment.VERSION
                }
            )
        })

    }

    public async showFeedback(item, mode: 'feedback' | 'bug' = 'feedback') {
        if (this.isFeedbackDialogOpen) {
            return;
        }

        this.isFeedbackDialogOpen = true;
        try {
            // Only capture a screenshot for bug reports (avoids delay for general feedback).
            const screenshotDataUrl = mode === 'bug' ? await this.captureFeedbackScreenshot() : null;

            const dialogRef = this.dialogService.open({
                title: `Send Feedback`,
                content: FeedbackComponent,
                height: 640,
                width: 600,
                minWidth: 520,
            });

            const contentRef = dialogRef.content as { instance?: FeedbackComponent };
            if (contentRef?.instance) {
                contentRef.instance.setMode(mode);
                if (screenshotDataUrl) {
                    contentRef.instance.setScreenshot(screenshotDataUrl);
                }
            }

            await dialogRef.result.toPromise();
        } finally {
            this.isFeedbackDialogOpen = false;
        }
    }

    private async captureFeedbackScreenshot(): Promise<string | null> {
        const { default: html2canvas } = await import('html2canvas-pro');
        const captureOptions: Parameters<typeof html2canvas>[1] = {
            logging: false,
            useCORS: true,
            scale: 1,
            width: window.innerWidth,
            height: window.innerHeight,
            x: window.scrollX,
            y: window.scrollY,
            // Always sanitize cloned DOM — html2canvas v1.4.1 can't parse modern
            // CSS color() functions (e.g. from Kendo/Tailwind themes) and throws.
            onclone: (clonedDoc: Document) => this.applyScreenshotFallbackStyles(clonedDoc),
        };

        try {
            const canvas = await html2canvas(document.body, captureOptions);
            return canvas.toDataURL('image/png');
        } catch (error) {
            console.warn('[Feedback] Screenshot generation failed.', error);
            return null;
        }
    }

    private applyScreenshotFallbackStyles(doc: Document): void {
        // Inject a blanket override to suppress box-shadows and decorative styles
        // that can cause rendering artifacts in the canvas capture.
        const override = doc.createElement('style');
        override.textContent = `
            *, *::before, *::after {
                box-shadow: none !important;
                text-shadow: none !important;
            }
            body { background: #ffffff !important; }
        `;
        doc.head.appendChild(override);
    }

    public showSubscription() {
        const dialogRef = this.dialogService.open({
            title: `Purchase FlowStudio Subscription`,
            content: SubscriptionPaymentComponent,
            minWidth: 700,
            width: 900,
            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });

        dialogRef.result.toPromise().then((result: DialogCloseResult) => {
            //return this.storageRouterService.updateSettings({ _id: Settings.SETTING_LASTSUB, value: LAST_SUB });
            return this.storageRouterService.putConfig(
                Settings.SETTING_LASTSUB,
                {
                    key: Settings.SETTING_LASTSUB,
                    value: LAST_SUB
                }
            )
        });
    }

    public showServices() {
        const dialogRef = this.dialogService.open({
            title: `Consulting & Support Services`,
            content: ServicesComponent,
            height: 500,
            minWidth: 400,
            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });

        // dialogRef.result.toPromise().then((result: DialogCloseResult) => {
        //     //return this.storageRouterService.updateSettings({ _id: Settings.SETTING_LASTSUB, value: LAST_SUB });
        //     return this.storageRouterService.putConfig(
        //         Settings.SETTING_LASTSUB,
        //         {
        //             key: Settings.SETTING_LASTSUB,
        //             value: LAST_SUB
        //         }
        //     )
        // });
    }

    public showMcp() {
        this.dialogService.open({
            title: `FlowStudio MCP`,
            content: McpAnnounceComponent,
            height: 300,
            minWidth: 400,
        });
    }

    public showWhatsNew() {
        this.dialogService.open({
            title: `What's New`,
            content: WhatsNewComponent,
            height: 480,
            width: 560,
            minWidth: 400,
        });
    }

    /** Header button visibility — hides itself once the webinar day has passed. */
    get webinarActive(): boolean {
        return isWebinarActive();
    }

    public showWebinar() {
        this.markWebinarSeen();
        this.dialogService.open({
            title: `Live Webinar`,
            content: WebinarPromoComponent,
            width: 560,
            minWidth: 320,
            cssClass: 'webinar-dialog',
        });
    }

    /**
     * Auto-show the webinar promo at most once per browser. The flag is written
     * when the dialog OPENS (not on close) so a refresh mid-dialog can't
     * re-trigger it. The header button reopens it on demand thereafter.
     */
    private maybeAutoShowWebinar(): void {
        if (this.webinarAutoShowChecked) {
            return;
        }

        if (!this.loggedIn || this.isIframe || !this.isApp() || !isWebinarActive()) {
            return;
        }

        if (this.hasSeenWebinar()) {
            this.webinarAutoShowChecked = true;
            return;
        }

        if (this.router.url.includes('oauth-callback')) {
            return;
        }

        this.webinarAutoShowChecked = true;

        setTimeout(() => {
            // Never stack on top of the blocking re-auth modal.
            if (this.msalHelperService.reauthPromptModal$.value) {
                this.webinarAutoShowChecked = false;
                return;
            }
            this.appInsights.trackEvent('webinar-promo', { action: 'auto-show', slug: WEBINAR_SLUG });
            this.showWebinar();
        }, 1500);
    }

    private hasSeenWebinar(): boolean {
        try {
            return window.localStorage.getItem(WEBINAR_SEEN_KEY) === '1';
        } catch {
            // Storage blocked (private mode / policy) — treat as seen so we never nag.
            return true;
        }
    }

    private markWebinarSeen(): void {
        try {
            window.localStorage.setItem(WEBINAR_SEEN_KEY, '1');
        } catch {
            // ignore — worst case the promo shows again next session
        }
    }

    private checkBuyIntent() {
        const raw = sessionStorage.getItem('fs_buy_intent');
        if (raw) {
            sessionStorage.removeItem('fs_buy_intent');
            try {
                const intent = JSON.parse(raw);
                setTimeout(() => this.paymentService?.checkout(intent.plan, intent.yearly), 500);
            } catch {
                setTimeout(() => this.paymentService?.checkout(raw as 'pro' | 'teams'), 500);
            }
        }
    }

    get isNewUI(): boolean {
        return true; // this.router.url.startsWith("/demo");
    }

    get version(): string {
        return environment.VERSION;
    }

    get visibleNav(): any[] {
        return this.nav.filter(item => !item.hidden);
    }

    get topNavItems(): any[] {
        return this.visibleNav.slice(1).filter(item => item.internal !== 'Feedback');
    }

    get environmentOptions(): any[] {
        return this.menu?.[1]?.items || [];
    }

    get environmentLabel(): string {
        return this.menu?.[1]?.text || 'Environment';
    }

    get userMenuOptions(): any[] {
        return this.menu?.[0]?.items || [];
    }

    onTopNavSelect(item: any): void {
        if (item?.url && item?.target) {
            window.open(item.url, item.target, 'noopener,noreferrer');
            return;
        }
        this.onSelect({ item });
    }

    toggleMenu(menu: 'environment' | 'user'): void {
        if (menu === 'environment') {
            this.environmentMenuOpen = !this.environmentMenuOpen;
            this.userMenuOpen = false;
            this.refreshProgressOpen = false;
        } else {
            this.userMenuOpen = !this.userMenuOpen;
            this.environmentMenuOpen = false;
            this.refreshProgressOpen = false;
        }
    }

    toggleRefreshProgress(): void {
        this.refreshProgressOpen = !this.refreshProgressOpen;
        this.environmentMenuOpen = false;
        this.userMenuOpen = false;
    }

    closeMenus(): void {
        this.environmentMenuOpen = false;
        this.userMenuOpen = false;
        this.refreshProgressOpen = false;
    }

    onEnvironmentAction(item: any): void {
        this.closeMenus();
        if (item) {
            this.onSelect({ item });
        }
    }

    onUserAction(item: any): void {
        this.closeMenus();
        if (item) {
            this.onSelect({ item });
        }
    }

    public onReauthBannerAction(): void {
        this.msalHelperService.beginReauthFromBanner();
    }

    public continueReauthFromModal(): void {
        this.msalHelperService.beginReauthFromBanner();
    }

}
